var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_583_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09188 19.338L5.978 23.4962L1.90681 23.5823C0.690125 21.3257 0 18.7437 0 16C0 13.3468 0.64525 10.8448 1.789 8.64172H1.78988L5.41437 9.30622L7.00212 12.909C6.66981 13.8778 6.48869 14.9178 6.48869 16C6.48881 17.1745 6.70156 18.2998 7.09188 19.338Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7203 13.011C31.904 13.9789 31.9998 14.9784 31.9998 16C31.9998 17.1455 31.8794 18.2629 31.6499 19.3407C30.8711 23.0084 28.8359 26.211 26.0166 28.4774L26.0157 28.4765L21.4504 28.2436L20.8043 24.2101C22.6751 23.113 24.1371 21.396 24.9072 19.3407H16.3516V13.011H25.032H31.7203Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0152 28.4764L26.0161 28.4773C23.2742 30.6813 19.7911 31.9999 15.9994 31.9999C9.90625 31.9999 4.60869 28.5943 1.90625 23.5824L7.09131 19.338C8.4425 22.9441 11.9212 25.5112 15.9994 25.5112C17.7524 25.5112 19.3946 25.0373 20.8038 24.2101L26.0152 28.4764Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2128 3.6835L21.0295 7.927C19.5711 7.01538 17.8471 6.48875 16.0001 6.48875C11.8295 6.48875 8.28575 9.17356 7.00225 12.909L1.78994 8.64175H1.78906C4.45194 3.50769 9.81631 0 16.0001 0C19.8822 0 23.4418 1.38287 26.2128 3.6835Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_583_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1105a4ed90e281ba6df0f2f73edf6acb.svg";
export { ForwardRef as ReactComponent };